var GoogleMaps = /** @class */ (function () {
    function GoogleMaps() {
    }
    GoogleMaps.openMap = function (event, markerJson, gipslist) {
        if (gipslist === void 0) { gipslist = null; }
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('registerMapPoints', {
            'detail': { markers: JSON.stringify(markerJson), gipslist: gipslist }
        }));
    };
    GoogleMaps.getMapMarkers = function (packageProductOrProducts) {
        var packageProducts = [];
        packageProducts = packageProducts.concat(packageProductOrProducts);
        var markers = {
            'points': []
        };
        for (var i in packageProducts) {
            var marker = {
                'packageProduct': packageProducts[i],
                'lat': packageProducts[i].hotel.location.latitude,
                'lng': packageProducts[i].hotel.location.longitude,
                'id': packageProducts[i].hotel.code,
                'ajax': true,
                'title': packageProducts[i].hotel.name
            };
            markers.points.push(marker);
        }
        return markers;
    };
    return GoogleMaps;
}());
export default GoogleMaps;
